import { useEffect, useState } from "react";

const STORAGE_KEY = "welope.landing.cookieConsentAcknowledged";

export function CookieConsent(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  function acknowledge() {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] flex justify-center p-4">
      <div className="flex w-full max-w-[640px] flex-col gap-3 rounded-2xl border border-outline-variant/40 bg-surface-container-lowest p-5 shadow-bloom-lg sm:flex-row sm:items-center sm:justify-between">
        <p className="font-body text-body-sm text-on-surface-variant">
          Diese Seite setzt keine Tracking- oder Marketing-Cookies. Nur wenn du dich für die
          Warteliste einträgst, speichern wir deine E-Mail-Adresse dafür.{" "}
          <a
            href="https://app.welope.de/datenschutz"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-secondary hover:opacity-80"
          >
            Mehr erfahren
          </a>
          .
        </p>
        <button onClick={acknowledge} className="btn-primary shrink-0 whitespace-nowrap">
          Verstanden
        </button>
      </div>
    </div>
  );
}
